<template>
  <el-container class="captcha-box">
    <el-button type="primary" class="send-btn" :class="isH5 ? 'send-btn-h5' : ''" :size="props.size" :disabled="!canSend" @click="loadCaptcha" plain>
      {{ btnText }}
    </el-button>

    <el-dialog
        v-model="showCaptcha"
        :close-on-click-modal="true"
        :show-close="false"
        style="width: 90%; max-width: 360px"
    >
      <!-- <captcha-plus
        :max-dot="maxDot"
        :image-base64="imageBase64"
        :thumb-base64="thumbBase64"
        width="300"
        @close="showCaptcha = false"
        @refresh="handleRequestCaptCode"
        @confirm="handleConfirm"
      /> -->
    </el-dialog>
  </el-container>
</template>

<script setup>
// 发送短信验证码组件
import {ref} from "vue";
import lodash from "lodash";
import {validateMobile} from "@/utils/validate";
import {ElMessage} from "element-plus";
import {httpGet, httpPost} from "@/utils/http";
import CaptchaPlus from "@/components/CaptchaPlus.vue";

const props = defineProps({
  mobile: String,
  size: String,
  isH5: Boolean
});
const btnText = ref("发送验证码");
const canSend = ref(true);
const showCaptcha = ref(false);
const maxDot = ref(5);
const imageBase64 = ref("");
const thumbBase64 = ref("");
const captKey = ref("");
const dots = ref(null);

const handleRequestCaptCode = () => {
  httpGet("/api/captcha/get")
      .then((res) => {
        const data = res.data;
        imageBase64.value = data.image;
        thumbBase64.value = data.thumb;
        captKey.value = data.key;
      })
      .catch((e) => {
        ElMessage.error("获取人机验证数据失败：" + e.message);
      });
};

const handleConfirm = (dots) => {
  if (lodash.size(dots) <= 0) {
    return ElMessage.error("请进行人机验证再操作");
  }

  let dotArr = [];
  lodash.forEach(dots, (dot) => {
    dotArr.push(dot.x, dot.y);
  });
  dots.value = dotArr.join(",");
  httpPost("/api/captcha/check", {
    dots: dots.value,
    key: captKey.value
  })
      .then(() => {
        // ElMessage.success('人机验证成功')
        showCaptcha.value = false;
        sendMsg();
      })
      .catch(() => {
        ElMessage.error("人机验证失败");
        handleRequestCaptCode();
      });
};

const loadCaptcha = () => {
  if (!validateMobile(props.mobile)) {
    return ElMessage.error("请输入合法的手机号");
  }
  sendMsg();
  // showCaptcha.value = true;
  // handleRequestCaptCode(); // 每次点开都刷新验证码
};

const sendMsg = () => {
  if (!canSend.value) {
    return;
  }

  canSend.value = false;
  httpPost("/api/sms/code", {
    mobile: props.mobile,
    key: captKey.value,
    dots: dots.value
  })
      .then(() => {
        ElMessage.success("短信发送成功");
        let time = 120;
        btnText.value = time;
        const handler = setInterval(() => {
          time = time - 1;
          if (time <= 0) {
            clearInterval(handler);
            btnText.value = "重新发送";
            canSend.value = true;
          } else {
            btnText.value = time;
          }
        }, 1000);
      })
      .catch((e) => {
        canSend.value = true;
        ElMessage.warning(e.message);
      });
};
</script>

<style lang="stylus">

.captcha-box {
  .send-btn {
    width: 100%;
    border: none
    color: #6289FB;
    background: #DBEDFF;
    border-color: #DBEDFF;
    border-radius: 10px;
    font-size: fs = 16px;
    padding-top: pt = 8px;
    padding-bottom: pb = 8px;
    padding-left: pl = 15px;
    padding-right: pr = 15px;
    height: 100%
    @media screen and (max-width: 1440px) {
      font-size fs * 0.75;
      padding-top: pt  * 0.75
      padding-bottom: pb  * 0.75
      padding-left: pl  * 0.75
      padding-right: pr  * 0.75;
    }
    @media screen and (max-width: 1366px) {
      font-size fs * 0.71;
      padding-top: pt  * 0.71;
      padding-bottom: pb  * 0.71
      padding-left: pl  * 0.71
      padding-right: pr  * 0.71;
      height: 24px
    }
  }

  .send-btn-h5 {
    height: 28px;
    padding: 0 8px;

  }

  .el-dialog {
    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      //padding 0
    }
  }
}

.el-message {
  z-index: 10000 !important;
}
</style>
